<section class="invoice-row-group-form">
  <app-form-header [menuDefinition]="menuDefinition" [showSave]="canManageInvoiceRowGroups" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>
  @if (form) {
    <form class="invoice-row-group-form__form astral-content-width astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
      <section class="astral-section-surface astral-stack-m">
        <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input [control]="form.controls['caption']"></astral-input>
        </astral-layout-group>
      </section>
    </form>
  }
</section>
